export default function toDateLong(Authentication, dateFilter) {
  'ngInject';

  return function link(date, dayFormat) {
    const _dayFormat = dayFormat || 'EEEE';
    const format = Authentication.user.settings.usTimeFormat
      ? `${_dayFormat}, MMM dd, yyyy`
      : `${_dayFormat} dd MMM yyyy`;
    return dateFilter(date, format);
  };
}
